import { render, staticRenderFns } from "./download.vue?vue&type=template&id=b29e657a&scoped=true&lang=pug"
var script = {}
import style0 from "./download.vue?vue&type=style&index=0&id=b29e657a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b29e657a",
  null
  
)

export default component.exports